import { render, staticRenderFns } from "./StaffVehicle.vue?vue&type=template&id=a83708d6&"
import script from "./StaffVehicle.vue?vue&type=script&lang=js&"
export * from "./StaffVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports